import styled, { css } from 'styled-components';
import { FormMessage } from '../form-message/index.js';
import { Icon } from '../icon/index.js';
import {} from './index.js';
import { getMargins, SYS_SPACE_FIXED_100, SYS_SPACE_FIXED_150, SEM_BORDER_WIDTH_FORMS_ACTIVE, SEM_BORDER_WIDTH_FORMS_DEFAULT, SEM_TYPOGRAPHY_FORMS_LABEL, getTypographyStyles, SYS_SIZE_FIXED_300 } from '@oneaudi/unified-web-common';
const inputPaddingRightDouble = 48 + parseFloat(SYS_SIZE_FIXED_300);
const inputPaddingRightSingle = 24 + parseFloat(SYS_SIZE_FIXED_300);
const inputPaddingLeft = 24 + parseFloat(SYS_SPACE_FIXED_150);
export const StyledButtonContainer = styled.div `
  transform: translateY(-50%);
  position: absolute;
  right: 0;
  top: 50%;
  display: flex;
  gap: ${SYS_SPACE_FIXED_100};
`;
export const StyledButton = styled.button `
  line-height: 0;
  cursor: pointer;
  padding: 0;
  background-color: transparent;
  border: none;
`;
export const StyledLabel = styled.label `
  position: absolute;
  left: ${inputPaddingLeft}px;
  ${getTypographyStyles(SEM_TYPOGRAPHY_FORMS_LABEL)}
  color: ${(props) => props.theme.sem.color.forms.foreground.text.default};
  opacity: ${(props) => (props.hasValue ? '0' : '1')};
  pointer-events: none;

  // TODO: token missing
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  transition-duration: 250ms;
  transition-property: opacity;
`;
export const StyledSearchIcon = styled(Icon) `
  pointer-events: none;
  position: absolute;
  color: ${(props) => props.theme.sem.color.forms.foreground.icons.default};
`;
export const StyledButtonIcon = styled(Icon) `
  flex-shrink: 0;
  color: ${(props) => props.theme.sem.color.forms.foreground.icons.default};
`;
export const StyledFormMessage = styled(FormMessage) `
  padding-top: ${SYS_SIZE_FIXED_300};
`;
export const StyledInput = styled.input `
  flex: 1 0 auto;
  color: ${(props) => props.theme.sem.color.forms.foreground.text.default};
  ${getTypographyStyles(SEM_TYPOGRAPHY_FORMS_LABEL)}
  background-color: transparent;

  &::-webkit-search-decoration,
  &::-webkit-search-cancel-button,
  &::-webkit-search-results-button,
  &::-webkit-search-results-decoration {
    display: none;
  }

  // TODO: token missing
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  transition-duration: 250ms;
  transition-property: box-shadow;

  ${(props) => props.value && props.additionalButton
    ? css `
          padding: ${SYS_SPACE_FIXED_150} ${inputPaddingRightDouble}px
            ${SYS_SPACE_FIXED_100} ${inputPaddingLeft}px;
        `
    : props.value
        ? css `
            padding: ${SYS_SPACE_FIXED_150} ${inputPaddingRightSingle}px
              ${SYS_SPACE_FIXED_100} ${inputPaddingLeft}px;
          `
        : css `
            padding: ${SYS_SPACE_FIXED_150} 0 ${SYS_SPACE_FIXED_100}
              ${inputPaddingLeft}px;
          `}

  border: 0;
  box-shadow: inset 0 -${SEM_BORDER_WIDTH_FORMS_DEFAULT} 0 0 ${(props) => props.theme.sem.color.forms.surface.underline.stroke.default};

  &:focus {
    box-shadow: inset 0 -${SEM_BORDER_WIDTH_FORMS_ACTIVE} 0 0 ${(props) => props.theme.sem.color.forms.surface.underline.stroke.interactive};

    + ${StyledLabel} {
      opacity: 0;
    }
  }

  &:disabled {
    cursor: not-allowed;
    box-shadow: inset 0 -${SEM_BORDER_WIDTH_FORMS_DEFAULT} 0 0 ${(props) => props.theme.sem.color.forms.surface.underline.stroke.disabled};
    color: ${(props) => props.theme.sem.color.forms.foreground.text.disabled};

    + ${StyledLabel} {
      cursor: not-allowed;
      color: ${(props) => props.theme.sem.color.forms.foreground.text.disabled};
    }

    ~ ${StyledButtonContainer} {
      ${StyledButtonIcon} {
        cursor: not-allowed;
        color: ${(props) => props.theme.sem.color.forms.foreground.icons.disabled};
      }
    }
  }
`;
export const StyledInner = styled.div `
  position: relative;
  display: flex;
  gap: ${SYS_SPACE_FIXED_150};
  align-items: center;
  justify-content: space-between;

  :has(${StyledInput}:disabled) {
    ${StyledSearchIcon} {
      cursor: not-allowed;
      color: ${(props) => props.theme.sem.color.forms.foreground.icons.disabled};
    }
  }
`;
export const StyledOuter = styled.div `
  margin: ${(props) => getMargins(props.margin)};
  min-width: 288px;
`;
//# sourceMappingURL=index.styles.js.map